module.exports = __webpack_public_path__ + "img/weekly-settle-earning.562b40ea.png";